module.exports = __webpack_public_path__ + "static/media/bene.96244ff0.jpg";